'use strict';

var Inflections = require('../../common/var/Inflections'),
    InflectionSet = require('../var/InflectionSet');

function addInflection(type, rule, replacement) {
  if (!Inflections[type]) {
    Inflections[type] = new InflectionSet;
  }
  Inflections[type].add(rule, replacement);
}

module.exports = addInflection;